module.exports = __webpack_public_path__ + "static/img/introduceBg.0eed1892.png";